import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import WhoWeAre from './pages/WhoWeAre';
import OurCoreXperts from './pages/OurCoreXperts';
import OurInterns from './pages/OurInterns';
import OurServices from './pages/OurServices';
import OurProducts from './pages/OurProducts';
import Blog from './pages/Blog';
import Careers from './pages/Careers';
import Contact from './components/Contact';
import RequestQuote from './pages/Quote';
import CustomSoftware from './pages/custom-software-development';
import ITConsulting from './pages/it-support-services';
import CloudServices from './pages/cloud-service-providers';
import BusinessProcessOutsourcing from './pages/bpo-services';
import DataAnalyticsServices from './pages/data-analytics-services';
import DigitalMarketingServices from './pages/digital-marketing-services';
import UIUXDesignServices from './pages/UIUXDesignServices';
import LauraTekLMS from './pages/lauratek-lms';
import HRMSSoftware from './pages/hrms';
import OneStepMedi from './pages/OneStepMedi';
import AdvancedHMS from './pages/hospital';
import SchoolERP from './pages/school';
import SEO2025 from './pages/seo-blogs';
import Software2025 from './pages/software-2025';
import TermsAndConditions from './pages/terms';
import ReactJSEngineer from './pages/rect';
import DotNetEngineer from './pages/dotnet';
import FlutterEngineer from './pages/flutter';
import './App.css';
import OffPageSEO from './pages/OffPageSEO';
import PHPDeveloper from './pages/PHP Developer';
import FrontEndDeveloper from './pages/Front-End Developer';
import PythonDeveloper from './pages/Python Developer';
import InsideSalesExecutive from './pages/Inside Sales Executive';
import FieldMarketer from './pages/Field Marketer';
import BestSoftwareDevelopment from './pages/BestSoftwareDevelopment'
import Products from './pages/OurProducts';
import AdminDashboard from './pages/Admin';
import Leadership from './pages/leadership'
import LauraDashboard from './pages/laura_dashboard'
import CybersecurityServices from './pages/cybersecurity';
import SEO2025Strategies from './pages/leadership';
import LoginForm from './pages/Login_receipt';
import hms from './pages/hms'
import HMS from './pages/hms';
import SAMS from './pages/sams';
import LogSphere from './pages/Hisphare';
import LauraTek from './pages/lms2';
import DeviceAnalytics from './pages/kpi';
import DevTalent from './pages/devtalnet';
import ROB from './pages/Rob';
import ScrollToTop from "./components/ScrollToTop";
import EnrollmentReceiptForm from './pages/Receipt';
import Getstudent from './pages/Getstudent';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hms" element={<  HMS/>} />
          <Route path="/sams" element={<  SAMS/>} />
          <Route path="/hisphare" element={<  LogSphere/>} />
          <Route path="/lms2" element={<  LauraTek/>} />
          <Route path="/kpi" element={<  DeviceAnalytics/>} />
          <Route path="/devtalnet" element={<  DevTalent/>} />
          <Route path="/Rob" element={<  ROB/>} />
          

          <Route path="/login_receipt" element={<LoginForm />} />
          <Route path="/who-we-are" element={<WhoWeAre />} />
          <Route path="/our-corexperts" element={<OurCoreXperts />} />
          <Route path="/our-interns" element={<OurInterns />} />
          <Route path="/our-services" element={<OurServices />} />
          <Route path="/our-products" element={<Products />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/get-quoted" element={<RequestQuote />} />
          <Route path="/custom-software-development" element={<CustomSoftware />} />
          <Route path="/it-support-services" element={<ITConsulting />} />
          <Route path="/cloud-service-providers" element={<CloudServices />} />
          <Route path="/bpo-services" element={<BusinessProcessOutsourcing />} />
          <Route path="/data-analytics-services" element={<DataAnalyticsServices />} />
          <Route path="/digital-marketing-services" element={<DigitalMarketingServices />} />
          <Route path="/ui-ux-design-services" element={<UIUXDesignServices />} />
          <Route path="/cybersecurity-services" element={<CybersecurityServices />} />
          <Route path="/lauratek-lms" element={<LauraTekLMS />} />
          <Route path="/hrms" element={<HRMSSoftware />} />
          <Route path="/onestepmedi" element={<OneStepMedi />} />
          <Route path="/hospital" element={<AdvancedHMS />} />
          <Route path="/school" element={<SchoolERP />} />
          <Route path="/seo-blogs" element={<SEO2025 />} />
          <Route path="/software-2025" element={<Software2025 />} />
          <Route path="/leadership" element={< SEO2025Strategies />} />
          <Route path="/OffPageSEO" element={< OffPageSEO />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/PHPDeveloper" element={< PHPDeveloper />} />
          <Route path="/Front-End Developer" element={<FrontEndDeveloper />} />
          <Route path="/Python-Developer" element={<PythonDeveloper />} />
          <Route path="/Inside Sales Executive" element={<InsideSalesExecutive />} />
          <Route path="/FieldMarketer" element={<FieldMarketer />} />
          <Route path="/BestSoftwareDevelopment" element={<BestSoftwareDevelopment />} />
          <Route path="/Admin" element={<AdminDashboard />} />
          <Route path="/laura_dashboard" element={<LauraDashboard />} />
          <Route path="/Receipt" element={<EnrollmentReceiptForm />} />
          <Route path="/l" element={<LauraDashboard />} />
          <Route path='getstudent' element ={<Getstudent />} />

          
           
          <Route path="/connect-landing" element={<div>Connect Landing Page</div>} />
        </Routes>
      </div>
    </Router>
  );
}
 
export default App;